import { render } from "./ContactActionsPopover.vue?vue&type=template&id=aa5b0484&ts=true"
import script from "./ContactActionsPopover.vue?vue&type=script&lang=ts"
export * from "./ContactActionsPopover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__